import { render, staticRenderFns } from "./TransactionLog.vue?vue&type=template&id=d52c04a0&scoped=true"
import script from "./TransactionLog.vue?vue&type=script&lang=js"
export * from "./TransactionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52c04a0",
  null
  
)

export default component.exports